import React from 'react';

class FormatoSimplificado536901PlanGamer_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Formato Simplificado 536901 Plan Gamer';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_FORMATO_SIMPLIFICADO_1345225_R_GAMER_2022_V1.pdf?alt=media&token=9538c8ef-1f87-41c1-ab82-35f541bba259';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default FormatoSimplificado536901PlanGamer_pdf